import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import api from "../../api/api";
import Select from "react-select";
import { v4 as uuidv4 } from 'uuid';
import SpareList from "./Sparelist";
import Maintenance from "./Maintenance";
import ServiceCost from "./ServiceCost";

import Attachments from "../../UserControls/Attachments/Attachments"

// ServiceFormStyles component remains unchanged
const ServiceFormStyles = () => (
    <style jsx>{`
        .form-container {
            max-width: 1200px;
            margin: 20px auto;
            padding: 25px;
            background-color: #ffffff;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 2px solid #f0f0f0;
        }

        .page-title {
            font-size: 1.8em;
            color: #333;
            margin: 0;
        }
.form-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 25px;
}

.form-actions button {
    min-width: 1px;
}
        .tab-navigation {
            display: flex;
            border-bottom: 1px solid #ddd;
            margin-bottom: 20px;
            overflow-x: auto;
        }

        .tab-btn {
            background-color: transparent;
            border: none;
            padding: 10px 20px;
            cursor: pointer;
            font-size: 1em;
            color: #555;
            border-bottom: 3px solid transparent;
            transition: all 0.3s ease;
            white-space: nowrap; 
        }

        .tab-btn:hover {
            color: #007bff;
        }

        .tab-btn.active {
            color: #007bff; 
            border-bottom: 3px solid #007bff;
            font-weight: 600;
        }

        .service-tab-grid {
            display: grid;
            grid-template-columns: 1fr 1fr; 
            gap: 30px; 
            padding: 10px;
        }

        .form-group-column {
            display: flex;
            flex-direction: column;
        }

        .form-group-column label {
            font-weight: 600;
            color: #555;
            margin-top: 15px;
            margin-bottom: 5px;
            font-size: 0.95em;
        }

        .form-group-column input[type="text"],
        .form-group-column input[type="date"],
        .form-group-column select,
        .form-group-column textarea {
            padding: 10px 12px;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 1em;
            width: 100%;
            box-sizing: border-box; 
            transition: border-color 0.3s;
        }

        .form-group-column textarea {
            resize: vertical;
            min-height: 80px;
        }

        .read-only-input {
            background-color: #f7f7f7;
            color: #777;
            cursor: not-allowed;
        }

        .form-group-radio {
            margin-top: 15px;
            display: flex;
            flex-direction: column;
        }

        .form-group-radio > div {
            display: flex;
            gap: 15px;
            margin-top: 5px;
        }

        .form-group-radio label {
            font-weight: normal; 
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-top: 0;
            margin-bottom: 0;
            font-size: 1em;
        }
        
        .btn-primary {
            background-color: #007bff;
            color: white;
            border: none;
            padding: 11px 45px;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 500;
            transition: background-color 0.3s;
            text-align: center;
        }
        .btn-primary:disabled {
            background-color: #ccc;
            cursor: not-allowed;
        }
        .btn-secondary {
            background-color: #6c757d;
            color: white;
            border: none;
            padding: 10px 18px;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 500;
            transition: background-color 0.3s;
        }

        /* --- Spares List Styles --- */
        .spares-list-container {
            padding: 10px;
        }
        .spares-list-container h3 {
            margin-top: 0;
            margin-bottom: 15px;
            color: #333;
        }
        .spares-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
        }
        .spares-table th, .spares-table td {
            border: 1px solid #ddd;
            padding: 10px;
            text-align: left;
        }
        .spares-table th {
            background-color: #f4f4f4;
            font-weight: 600;
            color: #555;
        }
        .spares-table input[type="number"],
        .spares-table select,
        .spares-table input[type="text"] {
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 4px;
            width: 100%;
            box-sizing: border-box;
        }
        .btn-add-spare {
            background-color: #28a745; /* Green color */
            margin-bottom: 15px;
        }
        .btn-remove-spare {
            background-color: #dc3545; /* Red color */
            padding: 8px 12px;
            font-size: 0.9em;
        }

        .placeholder-tab {
            padding: 50px;
            text-align: center;
            color: #999;
            border: 2px dashed #eee;
            border-radius: 8px;
            font-style: italic;
            background-color: #fcfcfc;
            min-height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.2em;
        }

        .loading, .error {
            text-align: center;
            padding: 20px;
            font-size: 1.2em;
            margin-top: 50px;
        }
        .error {
            color: #dc3545;
            background-color: #f8d7da;
            border: 1px solid #f5c6cb;
            border-radius: 8px;
        }

        /* Adjust react-select to match form-group styling */
        .react-select-container {
            margin-top: 5px; /* Aligns the select element with the standard inputs */
            font-size: 1em; /* Ensures font size consistency */
        }
        /* Custom styles for react-select to mimic form input look */
        .react-select__control {
            border: 1px solid #ccc !important;
            border-radius: 6px !important;
            padding: 3px 0 !important; /* Adjust vertical padding */
            min-height: 42px !important; /* Ensure min height is similar to input */
            box-shadow: none !important;
            transition: border-color 0.3s;
        }
        .react-select__control--is-focused {
            border-color: #80bdff !important; /* Optional: Focus color */
        }
        .react-select__placeholder {
            color: #aaa !important;
        }
        .react-select__single-value {
            color: #333 !important;
        }
        .react-select__indicator-separator {
            background-color: #ccc !important;
        }
        .react-select__dropdown-indicator {
            color: #ccc !important;
        }
        .react-select__option--is-selected {
            background-color: #007bff !important;
            color: white !important;
        }
        .react-select__option--is-focused {
            background-color: #e6f7ff !important;
        }
        .react-select__indicator {
            padding: 8px !important;
        }
        .react-select__clear-indicator {
            cursor: pointer;
        }

        @media (max-width: 800px) {
            .service-tab-grid {
                grid-template-columns: 1fr; 
                gap: 0;
            }
            .form-actions {
                margin-top: 15px;
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
        }

        /* --- Back Button --- */
.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #117fecff;
  color: #dce7e9ff;
  font-weight: 600;
  border: 1px solid #1086f5ff;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 5px rgba(213, 220, 221, 0.08);
}

.back-btn:hover {
  background-color: #0d77e0ff;
  transform: translateY(-1px);
}

.back-btn:active {
  background-color: #117eebff;
  transform: translateY(0);
}

.back-icon {
  font-size: 1.2rem;
  line-height: 1;
}
    .attachments-wrapper button {
  padding: 6px 12px !important;
  font-size: 13px !important;
  border-radius: 6px !important;
  height: auto !important;
}

    `}</style>
);


const getTodayDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const initialSpare = {
    tempId: uuidv4(), 
    SpareId: 0,
    SpareName: '',
    Quantity: 1,
    Unit: 'Nos',
    Remarks: ''
};


const ServiceForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const isEditingService = !isNaN(id) && id > 0;
    const initialTicketId = location.state?.ticketId || (isEditingService ? null : id); 

    const userName = sessionStorage.getItem("userName");
    const comid = sessionStorage.getItem("comid");

    // --- STATE FOR SERVICE DATA ---
    const [formData, setFormData] = useState({
        ServiceId: isEditingService ? parseInt(id) : 0,
        ServiceNo: isEditingService ? '...' : 'NEW',
        Start_Date: getTodayDate(),
        NextDueDate: getTodayDate(),
        TicketId: initialTicketId || '',
        AssetId: '',
        AssetName: '',
        ServiceDesc: '',
        IssueReason: '',
        Status: 'Open',
        ServiceType: 'Repair',
        IssueType: '',
        TicketIssueTitle: '', 

        PendingType: '',
        PendingReason: '',
        ServiceBy: userName ,
        Department: '',
        RaisedBy: '',
        BreakdownRectifyTime: getTodayDate(),
        comid: comid,
    });

   
    const [dropdownData, setDropdownData] = useState({
        tickets: [], 
        issueTypes: [],
        pendingTypes: [],
        serviceByUsers: [],
        allSpares: [{ SpareId: 1, SpareName: 'Oil Filter', Unit: 'Nos' }, { SpareId: 2, SpareName: 'Gasket', Unit: 'Pcs' }], 
    });

    const [sparesList, setSparesList] = useState([]);


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState("Service");


    
    const applyTicketDetails = (detail) => {
        if (!detail) return;

        setFormData(prev => {
            const isServiceRecord = detail.ServiceId && detail.ServiceId > 0;
            
            return {
                ...prev,
                // Ticket/Asset Details (from Ticket object)
                TicketId: detail.TicketId || prev.TicketId,
                AssetId: detail.AssetId || '',
                AssetName: detail.AssetName || '',
                 DeptId: detail.DeptId || '',  
                Department: detail.DeptName || '',
                RaisedBy: detail.UserName || '',
                TicketIssueTitle: detail.IssueTitle || prev.TicketIssueTitle,

                // Service Details (from Service object if present)
                ServiceId: isServiceRecord ? detail.ServiceId : 0,
                ServiceNo: isServiceRecord ? detail.ServiceNo : 'NEW',
                Start_Date: isServiceRecord && detail.Start_Date ? detail.Start_Date.substring(0, 10) : getTodayDate(),
                NextDueDate: isServiceRecord && detail.NextDueDate ? detail.NextDueDate.substring(0, 10) : getTodayDate(),
                ServiceDesc: isServiceRecord ? detail.ServiceDesc || '' : prev.ServiceDesc,
                Status: isServiceRecord ? detail.Status || 'Open' : prev.Status,
                ServiceType: isServiceRecord ? detail.ServiceType || 'Repair' : prev.ServiceType,
                IssueType: isServiceRecord ? detail.IssueType || '' : prev.IssueType, // Ensure IssueType is pulled from service record
                PendingType: isServiceRecord ? detail.PendingType || '' : prev.PendingType,
                PendingReason: isServiceRecord ? detail.PendingReason || '' : prev.PendingReason,
                ServiceBy: isServiceRecord ? detail.ServiceBy || userName  : prev.ServiceBy,
                BreakdownRectifyTime: isServiceRecord && detail.BreakdownRectifyTime ? detail.BreakdownRectifyTime.substring(0, 10) : getTodayDate(),
            };
        });
    };

    
   // ServiceForm.js (MODIFIED useEffect)

   useEffect(() => {
    const fetchFormData = async () => {
        try {
            setLoading(true);
            setError(null);

            const fetchParamForDropdowns = '0'; 

            const data = await api.GetAllTicketService(userName, fetchParamForDropdowns); 
            // MODIFICATION END
            
            const results = data.GetAllTicketServiceAPIjs || data; 

            if (results && results.Table && Array.isArray(results.Table)) {
                const ticketServiceData = results.Table;
                const issueTypeList = results.Table1 || []; 
                const pendingTypeList = results.Table2 || []; 
                const serviceNoTable = results.Table6 || [];

                setDropdownData(prev => ({
                    ...prev,
                    tickets: ticketServiceData,
                    issueTypes: issueTypeList,
                    pendingTypes: pendingTypeList, 
                }));

                if (serviceNoTable.length > 0 && !isEditingService) {
                    setFormData(prev => ({
                        ...prev,
                        ServiceNo: serviceNoTable[0].DocNo || "NEW",
                    }));
                }

                if (isEditingService) {
                    // Logic for loading an existing service by ID remains the same
                    const serviceResponse = await api.EditService(id);
                    const editData = serviceResponse.EditServiceAPIjs || serviceResponse;
                    
                    // ... (rest of the isEditingService block remains the same)
                    if (editData && editData.Table && editData.Table.length > 0) {
                        const serviceDetail = editData.Table[0];

                        setFormData(prev => ({
                            ServiceId: serviceDetail.ServiceId || prev.ServiceId,
                            ServiceNo: serviceDetail.ServiceNo || prev.ServiceNo,
                            Start_Date: serviceDetail.Start_Date ? serviceDetail.Start_Date.substring(0, 10) : getTodayDate(),
                            NextDueDate: serviceDetail.NextDueDate ? serviceDetail.NextDueDate.substring(0, 10) : getTodayDate(),
                            BreakdownRectifyTime: serviceDetail.BreakdownRectifyTime ? serviceDetail.BreakdownRectifyTime.substring(0, 10) : getTodayDate(),
                            TicketId: serviceDetail.TicketId || prev.TicketId,
                            TicketNo: serviceDetail.TicketNo || prev.TicketNo,
                            AssetId: serviceDetail.AssetId || prev.AssetId,
                            AssetName: serviceDetail.AssetName || prev.AssetName,
                            ServiceDesc: serviceDetail.ServiceDesc || prev.ServiceDesc,
                            IssueReason: serviceDetail.IssueReason || prev.IssueReason,
                            Status: serviceDetail.Status || prev.Status,
                            ServiceType: serviceDetail.ServiceType || prev.ServiceType,
                            IssueType: serviceDetail.IssueType || prev.IssueType,
                            PendingType: serviceDetail.PendingType || prev.PendingType,
                            PendingReason: serviceDetail.PendingReason || prev.PendingReason,
                            ServiceBy: serviceDetail.ServiceBy || prev.ServiceBy || userName,
                            Department: serviceDetail.Department || serviceDetail.DeptName || prev.Department,
                            DeptId: serviceDetail.DeptId || prev.DeptId, 
                            RaisedBy: serviceDetail.RaisedBy || serviceDetail.UserName || prev.RaisedBy,
                            TicketIssueTitle: serviceDetail.IssueName || serviceDetail.TicketIssueTitle || prev.TicketIssueTitle,
                            comid: serviceDetail.comid || prev.comid,
                        }));

                        // Load spares from DB
                        if (editData.Table2 && Array.isArray(editData.Table2)) {
                            const formattedSpares = editData.Table2.map(s => ({
                                tempId: uuidv4(),
                                SpareId: s.SpareId || 0,
                                SpareName: s.SpareName || "",
                                Quantity: s.Quantity || 1,
                                Unit: s.Unit || "Nos",
                                Remarks: s.Remarks || "",
                            }));
                            setSparesList(formattedSpares);
                        }
                    } else {
                        setError(`Service record ID ${id} not found.`);
                    }
                } else if (initialTicketId && ticketServiceData.length > 0) {
                    // Logic for loading a new service linked to a ticket remains the same
                    const ticketDetail = ticketServiceData.find(t => t.TicketId?.toString() === initialTicketId.toString());
                    if (ticketDetail) {
                        applyTicketDetails(ticketDetail);
                    } else {
                        setError(`Ticket ID ${initialTicketId} not found.`);
                    }
                }
            } else if (id && id !== '0') {
                setError(`No service or ticket found for ID: ${id}.`);
            } else if (initialTicketId && initialTicketId !== '0') {
                setError(`No ticket found for ID: ${initialTicketId}.`);
            }
        } catch (err) {
            console.error("Error fetching form data:", err);
            setError("Failed to load form data and dependencies.");
        } finally {
            setLoading(false);
        }
    };

    fetchFormData();
}, [userName, id, initialTicketId, isEditingService]); // Dependencies remain the same


    const ticketOptions = useMemo(() => {
        let filteredTickets = dropdownData.tickets;
        // if (formData.ServiceId !== 0 && formData.TicketId) {
        //      filteredTickets = dropdownData.tickets.filter(t => t.TicketId.toString() === formData.TicketId.toString());
        // }

        return filteredTickets.map(t => ({
            value: t.TicketId,
            label: `${t.TicketNo} - ${t.AssetName || 'N/A'} - ${t.DeptName || 'N/A'}`,
            TicketNo:t.TicketNo,
            data: t,
        }));
    }, [dropdownData.tickets, formData.ServiceId, formData.TicketId]);

    const issueTypeOptions = useMemo(() => {
        return dropdownData.issueTypes.map(i => ({
            value: i.IssueType,
            label: i.IssueType,
        }));
    }, [dropdownData.issueTypes]);

    const pendingTypeOptions = useMemo(() => {
        return dropdownData.pendingTypes.map(p => ({
            value: p.PendingType,
            label: p.PendingType,
        }));
    }, [dropdownData.pendingTypes]);


const selectedTicketOption = useMemo(() => {
    if (!formData.TicketId) return null;

    let option = ticketOptions.find(
        opt => opt.value?.toString() === formData.TicketId?.toString()
    );

    if (!option && formData.TicketNo) {
        option = {
            value: formData.TicketId,
            label: formData.TicketNo,
            TicketNo: formData.TicketNo,
            data: {
                TicketId: formData.TicketId,
                TicketNo: formData.TicketNo,
                AssetName: formData.AssetName,
                DeptName: formData.Department,
                UserName: formData.RaisedBy
                
            }
        };
    }

    return option || null;
}, [ticketOptions, formData.TicketId, formData.TicketNo, formData.AssetName, formData.Department, formData.RaisedBy]);

    
    const selectedIssueTypeOption = useMemo(() => {
        if (!formData.IssueType) return null;
        return issueTypeOptions.find(opt => opt.value === formData.IssueType) || null;
    }, [issueTypeOptions, formData.IssueType]);

    const selectedPendingTypeOption = useMemo(() => {
        if (!formData.PendingType) return null;
        return pendingTypeOptions.find(opt => opt.value === formData.PendingType) || null;
    }, [pendingTypeOptions, formData.PendingType]);


    
    // --- Handle Dropdown Changes (Updated for react-select) ---

    const handleTicketChange = (selectedOption) => {
        if (!selectedOption) {
            // Clear option selected
            setFormData(prev => ({ 
                ...prev, 
                TicketId: '',
                TicketNo: '',
                AssetId: '', 
                AssetName: '', 
                DeptId: '', 
                Department: '', 
                RaisedBy: '',
                IssueReason: '',
                TicketIssueTitle: '',
            }));
            return;
        }

        const selectedTicket = selectedOption.data;
        const selectedTicketId = selectedOption.value;

        setFormData(prev => ({
            ...prev,
            TicketId: selectedTicket.TicketId || selectedTicketId,
            TicketNo: selectedTicket.TicketNo || '', 
            AssetId: selectedTicket.AssetId || '',
            AssetName: selectedTicket.AssetName || '',
            DeptId: selectedTicket.DeptId || '', 
            Department: selectedTicket.DeptName || '',
            RaisedBy: selectedTicket.UserName || '',
            TicketIssueTitle: selectedTicket.IssueTitle || prev.TicketIssueTitle,
        }));
    };

    const handleIssueTypeChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            IssueType: selectedOption ? selectedOption.value : '',
        }));
    };

    const handlePendingTypeChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            PendingType: selectedOption ? selectedOption.value : '',
        }));
    };


    // --- 4. Handle General Input Changes (Unchanged) ---
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'radio' ? (checked ? value : prev[name]) : value,
        }));
    };



    // --- 6. Handle Save/Submission (Unchanged) ---
   const handleSave = async (e) => {
  e.preventDefault();

  if (!formData.TicketId || !formData.AssetName) {
    alert("Please select a Ticket and ensure Asset Name is populated.");
    return;
  }

  const userId = sessionStorage.getItem("userId") || ""; // optional
  const ipAddress = ""; // can fill later via backend
  const actionType = formData.ServiceId === 0 ? "INSERT" : "UPDATE";

   const getFullDateTime = (dateInput) => {
    const date = new Date(dateInput || new Date());
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  const payload = {
    ServiceId: formData.ServiceId,
    ServiceNo: formData.ServiceNo,
    ServiceStartTime: getFullDateTime(formData.Start_Date),   // ✅ full date+time
    ServiceEndTime: getFullDateTime(formData.BreakdownRectifyTime),
    ServiceById: userId,
    ServiceBy: formData.ServiceBy,
      NextDueDate: getFullDateTime(formData.NextDueDate),  
    AssetId: formData.AssetId,
    AssetName: formData.AssetName,
    Location: "", // optional
    IssueName: formData.TicketIssueTitle,
    ServiceDesc: formData.ServiceDesc,
    Status: formData.Status,
    ServiceType: formData.ServiceType,
    PendingType: formData.PendingType,
    PendingReason: formData.PendingReason,
    SerSheetName: "",
    Department: formData.Department,
   DeptId: formData.DeptId,
    TicketNo: formData.TicketNo,
    TicketId: formData.TicketId,
    CheckListStr: "",
    Sp_SqlAction: actionType,
    IssueReason: formData.IssueReason,
    IssueType: formData.IssueType,
    //ActualDateTime: new Date().toISOString(),
    ActualDateTime: (() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
})(),
    RaisedBy: formData.RaisedBy,
    IpAddress: ipAddress,
    comid: comid,
    SpareItems: JSON.stringify([]),
  };

try {
        setLoading(true);

        const response = await api.SaveService(payload);

        const savedServiceId = response?.data?.Table?.[0]?.ServiceId || response?.Table?.[0]?.ServiceId; 

        if (savedServiceId) {
            sessionStorage.setItem("ServiceId", savedServiceId);
            console.log("ServiceId stored in session:", savedServiceId);
        } else if (formData.ServiceId !== 0) {

            sessionStorage.setItem("ServiceId", formData.ServiceId.toString());
        }

        alert(`Service record ${actionType === 'INSERT' ? 'created' : 'updated'} successfully!`);
        navigate('/ServiceList');
    } catch (err) {
        console.error("Error saving service:", err);
        setError("Failed to save service record. Please try again.");
    } finally {
        setLoading(false);
    }
};


    // --- 8. Main Render Function ---
    return (
        <>
            <ServiceFormStyles />

            <div className="form-container">
                <div className="header">
  <h2 className="page-title">
    {formData.ServiceId === 0 ? "New Service" : `Edit Service: ${formData.ServiceNo}`}
  </h2>

  <button onClick={() => navigate("/ServiceList")} className="back-btn">
    <span className="back-icon">←</span> Back
  </button>
</div>


                <div className="tab-navigation">
                    <button
                        className={`tab-btn ${activeTab === "Service" ? "active" : ""}`}
                        onClick={() => setActiveTab("Service")}>
                        Service
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "SparesList" ? "active" : ""}`}
                        onClick={() => setActiveTab("SparesList")}>
                        Spares List
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "FutureMaintenanceActions" ? "active" : ""}`}
                        onClick={() => setActiveTab("FutureMaintenanceActions")}>
                        Future Maintenance Actions
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "ServiceCost" ? "active" : ""}`}
                        onClick={() => setActiveTab("ServiceCost")}>
                        Service Cost
                    </button>
                </div>

                <div className="tab-content">
                    {activeTab === "Service" && (
                        <form onSubmit={handleSave} className="service-tab-grid">
                            {/* --- Left Column --- */}
                            <div className="form-group-column">
                                <label>Service No</label>
                                <input type="text" value={formData.ServiceNo} readOnly className="read-only-input" />

                                <label>Breakdown Rectify Time</label>
                                <input type="date" name="BreakdownRectifyTime" value={formData.BreakdownRectifyTime} onChange={handleChange} />

                                <label>Ticket No</label>
                                <div className="react-select-container">
                                    <Select
                                        name="TicketId"
                                        value={selectedTicketOption}
                                        onChange={handleTicketChange}
                                        options={ticketOptions}
                                        placeholder="--Select--"
                                        isClearable
                                        // isDisabled={formData.ServiceId !== 0} 
                                        classNamePrefix="react-select"
                                    />
                                </div>


                                <label>Asset Name</label>
                                <input type="text" value={formData.AssetName} readOnly className="read-only-input" />
                               <label>Ticket</label>
                               <input type="text" value={formData.TicketIssueTitle} readOnly className="read-only-input" />

                                <label>Service Desc</label>
                                <textarea name="ServiceDesc" value={formData.ServiceDesc} onChange={handleChange} rows="2" />

                                <label>Issue Reason</label>
                                <textarea name="IssueReason" value={formData.IssueReason} onChange={handleChange} rows="2"/>

                                <div className="form-group-radio">
                                    <label>Status</label>
                                    <div>
                                        {['Open', 'InProcess', 'Pending', 'Closed', 'Verified'].map(status => (
                                            <label key={status}>
                                                <input
                                                    type="radio"
                                                    name="Status"
                                                    value={status}
                                                    checked={formData.Status === status}
                                                    onChange={handleChange}
                                                />
                                                {status}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="form-group-radio">
                                    <label>Service Type</label>
                                    <div>
                                        {['Prevention', 'Repair'].map(type => (
                                            <label key={type}>
                                                <input
                                                    type="radio"
                                                    name="ServiceType"
                                                    value={type}
                                                    checked={formData.ServiceType === type}
                                                    onChange={handleChange}
                                                />
                                                {type}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* --- Right Column --- */}
                            <div className="form-group-column">
                                <label>Start Date</label>
                                <input type="date" name="Start_Date" value={formData.Start_Date} onChange={handleChange} />

                                <label>Next Due Date</label>
                                <input type="date" name="NextDueDate" value={formData.NextDueDate} onChange={handleChange} />

                                <label>Service By</label>
                                <input type="text" name="ServiceBy" value={formData.ServiceBy} onChange={handleChange} placeholder="admin" />

                                <label>Department</label>
                                <input type="text" value={formData.Department} readOnly className="read-only-input" />

                                <label>Raised By</label>
                                <input type="text" value={formData.RaisedBy} readOnly className="read-only-input" />

                                <label>Issue Type</label>
                                <div className="react-select-container">
                                    <Select
                                        name="IssueType"
                                        value={selectedIssueTypeOption}
                                        onChange={handleIssueTypeChange}
                                        options={issueTypeOptions}
                                        placeholder="--Select--"
                                        isClearable
                                        classNamePrefix="react-select"
                                    />
                                </div>

                                <label>Pending Type</label>
                                <div className="react-select-container">
                                    <Select
                                        name="PendingType"
                                        value={selectedPendingTypeOption}
                                        onChange={handlePendingTypeChange}
                                        options={pendingTypeOptions}
                                        placeholder="--Select--"
                                        isClearable
                                        classNamePrefix="react-select"
                                    />
                                </div>

                                <label>Pending Reason</label>
                                <input type="text" name="PendingReason" value={formData.PendingReason} onChange={handleChange} />

<div className="attachments-wrapper">
                                            <div
                                              onClick={(e) => e.stopPropagation()}
                                              onFocus={(e) => e.stopPropagation()}
                                              style={{ margin: "20px 0" }}
                                            >
                                        <Attachments
                                                mdlId="ServiceForm"
                                                primeId={formData.ServiceId || 0}
                                                primeName={formData.ServiceNo || ""}
                                                uploadedBy={sessionStorage.getItem("userName")}
                                              />
                                            
                                            </div>
                                    </div>

                            </div>

                            <div className="form-actions" style={{ 
                 // Ensure it spans both columns if the service-tab-grid is a 2-column grid
                 gridColumn: '1 / -1', 
                 textAlign: "center", 
                 marginTop: "25px" 
             }}>
                <button className="btn-primary" type="submit" disabled={loading}>
                    {formData.ServiceId === 0 ? "Save" : "Update"}
                </button>
                {/* <button className="btn-secondary" onClick={() => navigate('/ServiceList')} type="button">
                    Cancel
                </button> */}
            </div>

                        </form>
                    )}
{activeTab === "SparesList" && (
<SpareList
  User={userName}
  TicketId={formData.TicketId}
  ServiceId={formData.ServiceId}

 
  />
)}
{activeTab === "FutureMaintenanceActions" && (
  <Maintenance
    User={userName}
    ServiceId={formData.ServiceId}
  />
)}
{activeTab === "ServiceCost" && (
  <ServiceCost
    User={userName}
    TicketId={formData.TicketId}
    ServiceId={formData.ServiceId}
  />
)}

                    {/* {activeTab !== "Service" && activeTab !== "SparesList" && (
                        <div className="placeholder-tab">
                            Content for **{activeTab.replace(/([A-Z])/g, ' $1').trim()}** goes here.
                        </div>
                    )} */}
                </div>
            </div>
        </>
    );
};

export default ServiceForm;